const work_info = [
  {
    image: 'https://drive.google.com/uc?id=1J2mW2Zkp_TGGC1Xj_uRMZkRxQIpqsrSG',
    alt: 'Philips',
    company: 'PHILIPS',
    role: 'Software Engineering Intern',
    period: 'Jan 2023-Jun 2023',
    desc: 'Part of the HSDP cloud team(HealthSuite Digital Platform) where I primarily worked on DICOMweb services(STOW, QIDO, WADO) with .NET Core, C#, REST API & Karate Framework.',
  },
  {
    image: 'https://drive.google.com/uc?id=1RIyNJaLIkQO9mpfKBaisNXc1SYwCVy4B',
    alt: 'MADIEE GAMES',
    company: 'MADIEE GAMES',
    role: 'Software Engineering Intern',
    period: 'Dec 2021-Jan 2022',
    desc: 'Collaborated in a team of 3 interns to work on developing a platform that incorporates MADIEE`s in-house developed games along with real-time chat and video conferencing of the members playing it.',
  },
  // {
  //   image: 'https://drive.google.com/uc?id=1y4FHIxV73xwaWKb4EEtBW9suffXdnpun',
  //   alt: 'Codechef-SRM-NCR',
  //   company: 'CODECHEF SRM-NCR CHAPTER',
  //   role: 'Core Team Member(CP Team)',
  //   period: 'May 2021-Present',
  //   desc: 'Responsible for setting problems for various online inter-college coding contests/events held on Codechef by Codechef SRM NCR Chapter for our peers so that they can improve their problem solving skills in a paced-environment.',
  // },
  // {
  //   image: 'https://merivis.org/wp-content/uploads/2018/02/Amazon-Logo-Transparent-PNG-300x300.png',
  //   alt: 'Amazon-image',
  //   company: 'Amazon',
  //   role: 'Software Developer - 1',
  //   period: '2018-2019',
  //   desc: 'Amazon is awesome',
  // },
];

export default work_info;